@if (mode === 'default') {
  <div class="demo-rich-editor-wrapper single">
    <slate-editable
      class="demo-slate-angular-editor"
      [editor]="editor"
      [(ngModel)]="value"
      (ngModelChange)="valueChange($event)"
      [renderElement]="renderElement()"
    >
    </slate-editable>
  </div>
}
@if (mode === 'component') {
  <div class="demo-rich-editor-wrapper single">
    @for (item of value; track $index) {
      <slate-editable
        class="demo-slate-angular-editor"
        [editor]="editor"
        [(ngModel)]="componentValue"
        (ngModelChange)="valueChange($event)"
        [renderElement]="renderElement()"
      >
      </slate-editable>
    }
  </div>
}
<ng-template #elementTemplate let-context="context" let-viewContext="viewContext">
  @if (context.element.type === 'heading-one') {
    <h1 slateElement [context]="context" [viewContext]="viewContext" [viewContext]="viewContext"></h1>
  }
</ng-template>
